<template>
  <div class="c-target-sport-nosport">
    <smart-icon :icon="type == 'sport' ? 'mdi-run' : 'mdi-walk'" :iconColor="type == 'sport' ? $color.coro['info-500'] : $color.coro['info-200'] " />
    <span class="c-target-sport-nosport__text"
        :style="{
            color: type == 'sport' ? $color.coro['info-500'] : $color.coro['info-200']
        }"
    >
      <sub>
        {{ type === 'sport'
          ? $ucfirst($t('questionnaires.STRESS_RELIEF_TECHNIQUES.option.SPORTS', { catalog: 'questionnaires' }))
          : $ucfirst($t('general.noSport', { catalog: 'app_mobile' })) }}
      </sub>
    </span>
  </div>
</template>

<script>
import SmartIcon from "./SmartIcon.vue";

/**
 * Component TargetSportNoSportIcon.vue
 *
 * @module TargetSportNoSportIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/components/Parts/TargetSportNoSportIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "TargetSportNoSportIcon",
  components: {
    SmartIcon,
  },
  props: {
    type: {
      type: String,
      default: () => "sport",
    },
  },
};
</script>

<style lang="scss">
.c-target-sport-nosport {
  display: inline-block;
}

.c-target-sport-nosport__text {
  margin-top: 8px;
}
</style>